import { useEffect, useState } from "react";
import { useAppDispatch } from "../store/hooks";

export function useAPIRsp<Req, Rsp>(
    method: (dispatch: any, req: Req) => Promise<Rsp>,
    req: Req,
    rspDefault: Rsp
): [Rsp, () => Promise<void>] {
    const dispatch = useAppDispatch();

    const [isBackend, setIsBackend] = useState(false);
    const [rsp, setRsp] = useState(rspDefault);

    const call = () => {
        return method(dispatch, req).then((rsp) => {
            setRsp(rsp);
            setIsBackend(true);
            return;
        });
    };
    useEffect(() => {
        if (isBackend) {
            return;
        }
        call();
    }, []);
    return [rsp, call];
}
